import { shutdownChat } from "../components/ChatWidget/registry";

export interface AuthData {
  uid?: string;
  "access-token"?: string;
  "token-type"?: string;
  client?: string;
  expiry?: string;
}

const AUTH_HEADERS: (keyof AuthData)[] = [
  "uid",
  "access-token",
  "client",
  "token-type",
  "expiry",
];

export function setAuthData(data: Partial<AuthData>): void {
  if (data) {
    AUTH_HEADERS.forEach((key) => {
      if (data[key] !== undefined) {
        localStorage.setItem(key, data[key]!);
      }
    });
  }
}

export function getAuthData(): AuthData {
  const data: AuthData = {};
  AUTH_HEADERS.forEach((key) => {
    const value = localStorage.getItem(key);
    if (value !== null) {
      data[key] = value;
    }
  });
  return data;
}

export async function clearAuthData(): Promise<void> {
  await shutdownChat();
  AUTH_HEADERS.forEach((key) => localStorage.removeItem(key));
}

// A session is anonymous when there is no token, or the boot profile fetch
// rejected the one we had. Shared by AuthorizedRoute (redirect to /signin) and
// LandingGate (render the marketing landing) so the two can't drift apart.
export function isAnonymousSession(authenticated: boolean | null): boolean {
  return !getAuthData()["access-token"] || authenticated === false;
}
